module.exports = __webpack_public_path__ + "img/mantenanceManage.4f4a1ad8.svg";